<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body"
    :class="{'is-hidden-header' : targetScrollFlg}"
    @scroll="handleScroll"
  >
  <BackgroundImage />

    <!-- menu:start -->
    <PCMenu
      class="visible"
      v-if="visibleMenu"
      @closeMenu="visibleMenu = false"
    />
    <!-- menu:end -->

    <div id="wrapper">
      <!-- header:start -->
      <header id="header" class="header">
        <PCButtonHistoryBack />
      </header>
      <!-- header:end -->

      <!-- menu-bar:start -->
      <!-- open -->
      <div class="menu-bar" role="button" 
        :class="{'is-open' : !targetScrollFlg}"
        @click="visibleMenu = !visibleMenu"
      >
        <IconMenu class="icn" 
          v-if="!targetScrollFlg"
        />
        <FontawesomeIcon :icon="['far','chevron-up']" size="lg" class="icn"
          v-if="targetScrollFlg"
        />
      </div>
      <!-- close -->
      <!-- menu-bar:end -->

      <!-- content:start -->
      <div id="content"
        style="height:calc(100vh - 84px);"
      >
        <div class="contact"
          @scroll="handleScroll"
        >
          <div class="contact-head">
            <div class="breadcrumb">
              <span class="breadcrumb-link">お見積もりのご依頼</span> ／ <span class="breadcrumb-link current">お見積もりご依頼内容の確認</span> ／ <span class="breadcrumb-link">お見積もりご依頼の完了</span>
            </div>
            <h1 class="hdg02">お見積もりご依頼内容の確認</h1>
          </div>
          <form @submit.prevent class="contact-container">
            <div class="contact-content">
              <p class="txt mb40">下記内容で見積もり依頼を送信いたします。内容をご確認いただき必要があれば「戻る」を押して修正してください。</p>
              <h2 class="hdg03 mb28">お見積もり内容</h2>
              <ul class="contact-content-list">
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th class="border-none">
                          <span class="contact-content-table-hdg">弊社紹介社員</span>
                        </th>
                        <td class="border-none">
                          <p class="contact-content-table-txt">{{ group1.introducer }}</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th class="border-none">
                          <span class="contact-content-table-hdg">備考</span>
                        </th>
                        <td class="border-none">
                          <p class="contact-content-table-txt" v-html="group1.noteDisp"></p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
              </ul>

              <h2 class="hdg03 mb28">見積もりを希望するパッケージ / 商品</h2>

              <FontawesomeIcon v-if="!group1.isPackageAndLicensesLoaded" :icon="['fal','spinner-third']" size="2x" class="mb12 icn fa-spin" />
              <template v-else>
                <p v-if="group1.productsLicensesDisp.length === 0">表示する内容がありません。</p>
                <template v-else>

                  <div v-for="(item, index) in group1.productsLicensesDisp" :key="'package_' + index" 
                    class="tbl04 box-package">
                    <div class="tbl04-hdgarea">
                      <h3 class="hdg03 mb20">{{ item.package_name }}</h3>
                    </div>
                    <div class="tbl04-bodyarea">


                      <table class="tbl04-table">
                        <colgroup>
                          <col style="width:55%;">
                          <col sytle="width:45%;">
                        </colgroup>
                        <thead>
                          <tr>
                            <th>&nbsp;</th>
                            <th>見積もりライセンス数</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item2, index2) in item.basic_products" :key="'basic_' + index2">
                            <th>
                              <div class="tbl04-table-txt">{{ item2.name }}</div>
                            </th>
                            <td>
                              <div class="tbl04-table-txt">{{ item2.license_number }}</div>
                            </td>
                          </tr>

                          <tr v-for="(item3, index3) in item.option_products" :key="'option_' + index3">
                            <th class="pl40">
                              <div class="tbl04-table-txt">{{ item3.name }}</div>
                            </th>
                            <td>
                              <div class="tbl04-table-txt">{{ item3.license_number }}</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                    </div>
                  </div>

                </template>
              </template>

              <div class="contact-submit">
                <router-link to="/pc/estimate-input" class="contact-submit-link">
                  <FontawesomeIcon :icon="['fas','angle-left']" class="icn" />
                  戻る
                </router-link>
                <div class="button contact-submit-button">
                  <button class="btn" @click="group1.onSubmitButtonClicked">見積もりを依頼</button>
                </div>
              </div>

            </div>
          </form>
        </div>
      </div>
      <!-- content:end -->
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
import PCMenu from '@/components/pc/popup/PCMenu.vue'
import * as logicLoggedinEstimate from '@/logic/estimate/LoggedinEstimate'

export default defineComponent({
  components: {
    PCMenu
  },
  setup (props, context) {

    onMounted(() => {
      // 初期表示
      group1.init()
    })

    const group1 = logicLoggedinEstimate.getGroupConfirm(props, context)
  
    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>
#content {
  background-color: #fff;
  border-radius: 8px 8px 0 0;
  margin-bottom: 60px;
  overflow-y: auto;
}
.breadcrumb {
  color: $color-content;
  font-size: 1.4rem;
  margin-bottom: 16px;
  &-link {
    color: $color-inactive;
    &.current {
      color: $color-content;
    }
  }
}
.contact {
  width: 100%;
  overflow: auto;
  &-container {
    border-top: 1px solid $color-line;
    padding: 40px 0;
    .button .btn[type="submit"] {
      width: 230px;
      margin: 32px auto 0;
    }
  }
  &-head {
    padding: 40px;
    [class^="hdg"] {
      margin-bottom: 0;
    }
  }
  &-content {
    max-width: 1105px;
    padding: 0 40px;
    margin: 0 auto;
    &-list {
      list-style: none;
      margin-bottom: 32px;
      &-item {
        border-top: 1px solid $color-line;
        padding: 32px 0;
        .contact-content-table {
          th,td {
            padding: 0 20px;
          }
        }
      }
    }
    &-table {
      width: 100%;
      border-collapse: collapse;
      .border-none {
        border: 0!important;
      }
      &.border-bottom {
        border-bottom: 1px solid $color-line;
      }
      thead {
        th {
          color: $color-sup;
          font-size: 1.6rem;
          font-weight: normal;
          padding: 16px 20px;
        }
      }
      tbody {
        th,td {
          padding: 16px 20px;
          border-top: 1px solid $color-line;
          vertical-align: baseline;
        }
      }
      &-hdg {
        display: block;
        color: $color-hdg;
        font-size: 1.6rem;
        font-weight: bold;
        &.is-inactive {
          color: $color-inactive;
        }
      }
      &-txt {
        color: $color-content;
        font-size: 1.6rem;
        line-height: 2;
      }
      &-sup {
        color: $color-sup;
        font-size: 1.4rem;
      }
      &-btnarea {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        .contact-content-table-link {
          margin-left: 20px;
        }
      }
      &-btn {
        width: 160px;
        .formparts.select .select-label,
        .button .btn {
          height: 32px;
        }
      }
      &-link {
        font-size: 1.6rem;
        color: $color-link;
      }
    }
  }
  &-submit {
    display: flex;
    align-items: center;
    justify-content: center;
    &-link {
      width: 80px;
      display: flex;
      align-items: center;
      color: $color-link;
      font-size: 1.4rem;
      @include hoverOpacity;
      .icn {
        margin-right: 10px;
      }
    }
    &-button {
      width: 230px;
      .btn {
        font-size: 1.4rem;
        @include hoverOpacity;
      }
    }
  }
}
.list-inline {
  a {
    @include hoverOpacity;
  }
}
.footer {
  margin-top: 72px;
  margin-bottom: 40px;
  text-align: center;
  a {
    font-size: 1.2rem;
  }
}
.box-package{
  border: 1px solid #ddd;
  border-radius: 5px;
  & + .box-package{
    margin-top: 50px;
  }
  .tbl04-hdgarea{
    border-top: none;
  }
  .tbl04-bodyarea{
    border-bottom: none;
    margin-bottom: 0;
  }
  & + .contact-submit{
    margin-top: 30px;
  }
}
</style>
